export default "__VITE_ASSET__C2Tq2Ftc__"